export default __webpack_public_path__ + "static/media/win7-paint.57035a17.jpg";